import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Text } from '@lusha-ui/text';
import React from 'react';
function UnsubscribeSuccess() {
    return (_jsxs("div", { children: [_jsx(Text, { variant: 'h3-s', textAlign: 'center', display: 'block', css: css `
          margin-bottom: 2px;
        `, children: "You\u2019ve successfully unsubscribed" }), _jsx(Text, { variant: 'body-2-r', textAlign: 'center', children: "Your preferences have been updated, and you won\u2019t receive these emails anymore. Thanks for helping us improve." })] }));
}
export default UnsubscribeSuccess;
